// Validación de los forms de «+ Paso» y de «Estado de redes» (tramo T4a del
// Avivador v2; contrato en components/avivador/panel-avivador-tipos.ts,
// `ContratoPasoValidacion`; §13 7.2 de context/design_avivador_v2.md). Pura,
// sin React: la usan `PasoForm` (paso-forms.tsx) y `EstadoRedesForm`
// (obras/estado-redes-dialog.tsx) para habilitar el primario y, en la variante
// 'avivador', para el «Falta: …» al lado del botón.
//
// En la variante 'obra' (la página de la obra, la home) la regla es la de
// siempre: la fecha de índices del chequeo es opcional (viene precargada con
// hoy) y la UI no muestra «Falta:».
// La firma la fija el test contra `ContratoPasoValidacion`.
import type { TipoValidacionPaso, ValoresPaso, VariantePaso } from '@/components/avivador/panel-avivador-tipos';

/** «Vacío» = undefined, null o solo espacios. */
function vacio(v: string | null | undefined): boolean {
  return v == null || v.trim() === '';
}

/** Los estados de redes que exigen nota (mismo criterio que el backend y
 *  EstadoRedesForm). */
function exigeNota(estado: ValoresPaso['estado']): boolean {
  return estado === 'No Aplica' || estado === 'Archivado';
}

/**
 * Lo que falta para poder registrar, en el orden y con los textos del
 * contrato: chequeo → 'período', 'fecha de índices' (solo en 'avivador');
 * monto → 'monto o %', 'período', 'fecha'; hito → 'fecha'; estado-redes →
 * 'el estado', 'la nota' (solo No Aplica / Archivado). Lo que no aplica al
 * tipo se ignora.
 */
export function faltantesPaso(tipo: TipoValidacionPaso, valores: ValoresPaso, variante: VariantePaso): string[] {
  const faltan: string[] = [];
  switch (tipo) {
    case 'chequeo':
      if (vacio(valores.periodo)) faltan.push('período');
      if (variante === 'avivador' && vacio(valores.fechaIndices)) faltan.push('fecha de índices');
      break;
    case 'monto':
      if (valores.monto == null && valores.pct == null) faltan.push('monto o %');
      if (vacio(valores.periodo)) faltan.push('período');
      if (vacio(valores.fecha)) faltan.push('fecha');
      break;
    case 'hito':
      if (vacio(valores.fecha)) faltan.push('fecha');
      break;
    case 'estado-redes':
      if (valores.estado == null) faltan.push('el estado');
      if (exigeNota(valores.estado) && vacio(valores.nota)) faltan.push('la nota');
      break;
  }
  return faltan;
}

/** [] → '' · ['a'] → 'a' · ['a','b'] → 'a y b' · ['a','b','c'] → 'a, b y c'.
 *  La UI arma «Falta: {unirFaltantes(f)}». */
export function unirFaltantes(faltantes: readonly string[]): string {
  if (faltantes.length <= 1) return faltantes[0] ?? '';
  return `${faltantes.slice(0, -1).join(', ')} y ${faltantes[faltantes.length - 1]}`;
}
